import { zwClient } from "@/sync/zapworks";

export const getAppClipCompatibleTriggers = async (projectId: string) => {
    const triggerArray = await zwClient.getTriggerInfo(projectId);
    return triggerArray.filter(trigger => {
        return trigger.type === "qr-code" || trigger.type === "deep-link";
    }) 
}